import { useDispatch } from "react-redux";
import { setPlayingMovies } from "../utils/store/slice/movieSlice";
import { TMDBOptions } from "../utils/tmdbOption";
import { useEffect } from "react";

const UseNowMovies = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, []);

  const getData = () => {
    fetch(
      `https://api.themoviedb.org/3/movie/now_playing?language=en-US&page=1`,
      TMDBOptions
    )
      .then((res) => res.json())
      .then((data) => {
        dispatch(setPlayingMovies(data.results));
      });
  };
};

export default UseNowMovies;
